import React from 'react';

import Hero from './components/Hero';
import Reviews from './Reviews';
import ContactIntro from './components/ContactIntro';


export default class extends React.Component {

  render() {
    return (
      <div>

        <Hero
          //h1split1="Zichtbaarheid die "
          h1split1="Ik maak LinkedIn "
          //h1split2="talent aantrekt."
          h1split2="gemakkelijk."
          h2="We starten met De Fundering: een strategische eerste stap waarin we jouw positionering, verhaal en LinkedIn ombouwen tot een magneet voor toptalent, investeerders, of klanten."
        />

        <Reviews limited />

        {/*<i id="upa"/>
        <div className="full-responsive accent" style={{background:"#116CB2"}}>
          <div className="wrap content-text">
            <h2 className="cta-title" style={{color:"#F2AA22"}}>Uitgebreide Profiel Analyse (UPA)</h2>
            <p style={{textAlign:"center", opacity:"0.8"}}>Ben jij benieuwd of jouw LinkedIn profiel professioneler kan zijn?<br/><br/>Vraag de gratis en vrijblijvende Uitgebreide Profiel Analyse aan! Ontvang binnen 3 werkdagen een uitgebreid document van 4-6 pagina's, met duidelijke tips om jouw LinkedIn profiel te verbeteren. Geen verplichtingen, gewoon eerlijke feedback.<br/><br/>Stuur mij direct een LinkedIn-berichtje met jouw aanvraag!</p>
            <div style={{textAlign:"center"}}><a href="https://www.linkedin.com/in/peterdotplus/" target="blank" rel="noopener noreferrer" className="btn btn-fat btn-if btn-if-fill-red">Direct naar LinkedIn</a></div>
          </div>
        </div>*/}

        {/*<div className="full-responsive black">
          <div className="wrap content-block" style={{textAlign:"center"}}>
            <h2 style={{marginBottom:".3em"}}>Gratis &amp; Waardevol</h2>
            <div><a href="/gratis" className="btn btn-fat btn-if btn-if-fill-gold">Bekijk /gratis</a></div>
          </div>
        </div>*/}

        {/*<div className="full-responsive black">
          <div className="wrap content-block" style={{textAlign:"center"}}>
            <h2 style={{ margin: "0" }}>3 uur LinkedIn Live Clinic</h2>
            <h3 style={{ margin: "0 0 1.2em" }}>Live Profiel Analyses: Hoe CEO's hun profiel kunnen verbeteren om meer toptalent aan te trekken.</h3>
            <div><a href="https://www.linkedin.com/events/7473655132887486464/?viewAsMember=true" target="_blank" rel="noopener noreferrer" className="btn btn-fat btn-if btn-if-fill-gold">Bekijk LinkedIn Live Event</a></div>
          </div>
        </div>*/}

        <div className="full-responsive black">
          <div className="wrap content-block" style={{textAlign:"center"}}>
            <h2 style={{marginBottom:".3em"}}>Diensten</h2>
            <div><a href="/diensten" className="btn btn-fat btn-if btn-if-fill-gold">Bekijk mijn diensten</a></div>
          </div>
        </div>

        <ContactIntro />

      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/Start.js